"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const lib_1 = require("@brandfree-front/lib");
const mobx_1 = require("mobx");
const mobx_react_1 = require("mobx-react");
const react_1 = __importDefault(require("react"));
const config_1 = __importDefault(require("../config"));
const StoresUtil_1 = require("../util/StoresUtil");
let AppHeader = class AppHeader extends react_1.default.Component {
    constructor(props) {
        super(props);
        Object.defineProperty(this, "ssoStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "locationStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "translateStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "section", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: ''
        });
        Object.defineProperty(this, "backButtonProps", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                const { translate } = this.translateStore;
                if (this.backButtonVisible) {
                    return {
                        backButton: {
                            text: translate('header.back'),
                            onClick: () => history.back()
                        }
                    };
                }
            }
        });
        Object.defineProperty(this, "getEmployeeBarLinks", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                const { translate } = this.translateStore;
                const baseUrl = config_1.default.teliaWebUrl;
                return [
                    {
                        label: translate('header.dealer.dashboard'),
                        url: `${baseUrl}/teenindus`
                    },
                    {
                        label: translate('header.dealer.dealerInfo'),
                        url: `${baseUrl}/teenindus/teenindusinfo`
                    },
                    {
                        label: translate('header.dealer.search'),
                        url: `${baseUrl}/teenindus/otsing`
                    },
                    {
                        label: translate('header.dealer.customer-card'),
                        url: `${baseUrl}/teenindus/kliendikaart`
                    },
                    {
                        label: translate('header.dealer.issues'),
                        url: `${baseUrl}/teenindus/syndmused`
                    }
                ];
            }
        });
        Object.defineProperty(this, "getEmployeeMenu", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                const auth = this.ssoStore.auth;
                let color;
                switch (config_1.default.componentTier) {
                    case 'test':
                        color = 'employee-test';
                        break;
                    case 'live':
                        color = 'employee';
                        break;
                    default:
                        color = 'employee-dev';
                }
                if (!(auth && auth.dealer)) {
                    return null;
                }
                return {
                    environment: config_1.default.componentTier,
                    segment: {
                        color,
                        items: this.getEmployeeBarLinks()
                    },
                    actions: {
                        items: [
                            {
                                id: 'employee-profile',
                                label: `${auth.dealer.displayName} (${auth.dealer.department})`,
                                icon: '#support',
                                showArrow: true,
                                dropdownContent: react_1.default.createElement(lib_1.Iframe, { url: config_1.default.ssoClientUrl.concat('/sso2/admin/config'), title: "Telia SSO" })
                            }
                        ]
                    }
                };
            }
        });
        Object.defineProperty(this, "handleOpenSectionChange", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (section) => {
                this.section = section;
                section === 'sso' ? this.ssoStore.openSsoIframe() : this.ssoStore.closeSsoIframe();
            }
        });
        (0, mobx_1.makeObservable)(this);
    }
    get ssoUiUrl() {
        if (this.ssoStore.isDealer) {
            return `${config_1.default.ssoClientUrl}/sso2/admin/mandates`;
        }
        return `${config_1.default.ssoClientUrl}/sso2?webapi=true&selectMandate=true&app=telia&locale=et&allowStatisticsCookies=true`;
    }
    get backButtonVisible() {
        var _a;
        const pathname = ((_a = this.locationStore.currentLocation) === null || _a === void 0 ? void 0 : _a.path) || window.location.pathname;
        return !(pathname[pathname.length - 1] === '/' || pathname.indexOf('/gdpr') > -1 || pathname.indexOf('/valideerimine') > -1);
    }
    render() {
        const { translate } = this.translateStore;
        const auth = this.ssoStore.auth;
        return (react_1.default.createElement(lib_1.Header, { languages: { items: this.locationStore.getHeaderLanguages() }, logo: {
                alt: 'logo',
                width: 280,
                srcset: `https://res.cloudinary.com/telia/image/upload/w_280,fl_lossy,f_auto,q_auto:best/gdpr/logod 280w,
                     https://res.cloudinary.com/telia/image/upload/fl_lossy,f_auto,q_auto:best/gdpr/logod 560w`
            }, actions: {
                sso: {
                    isSsoLoaded: this.ssoStore.loaded,
                    isLoggedIn: this.ssoStore.isLoggedIn
                },
                items: [
                    {
                        id: 'nav',
                        icon: '#menu-burger',
                        url: '#',
                        label: translate('header.menu'),
                        location: 'top'
                    },
                    {
                        id: 'sso',
                        url: '#',
                        icon: '#contact',
                        label: auth && auth.customer ? auth.customer.displayName : translate('header.logIn'),
                        dropdownContent: react_1.default.createElement(lib_1.Iframe, { url: this.ssoUiUrl, title: "Telia SSO" }),
                        location: 'top'
                    }
                ]
            }, ...this.backButtonProps(), onOpenSectionChange: this.handleOpenSectionChange, openSection: this.openSection, employee: this.getEmployeeMenu() }));
    }
    get openSection() {
        return this.ssoStore.isSsoIframeOpen ? 'sso' : this.section === 'sso' ? '' : this.section;
    }
};
__decorate([
    mobx_1.observable
], AppHeader.prototype, "section", void 0);
__decorate([
    mobx_1.computed
], AppHeader.prototype, "ssoUiUrl", null);
__decorate([
    mobx_1.action
], AppHeader.prototype, "handleOpenSectionChange", void 0);
__decorate([
    mobx_1.computed
], AppHeader.prototype, "openSection", null);
AppHeader = __decorate([
    StoresUtil_1.injectStores,
    mobx_react_1.observer
], AppHeader);
exports.default = AppHeader;
